import gsap from "gsap";
import { magnificPopupInline } from '../../../src/js/popups'


function closeAllAccordions(accordions, clickedAccordion) {
  accordions.forEach((accordion) => {
    if (accordion === clickedAccordion) return; // skip the clicked accordion

    const content = accordion.querySelector(
      '[data-target="accordion-content"]'
    );
    accordion.dataset.state = "closed";
    gsap.to(content, { height: 0, duration: 0.5 });
    gsap.to(accordion.querySelector(".icon .plus-vertical"), {
      rotate: "0deg",
      transformOrigin: "center",
      duration: 0.5,
    });
  });
}

function openAllAccordions() {
  const accordions = document.querySelectorAll('[data-target="accordion"]');
  accordions.forEach((accordion) => {
    const content = accordion.querySelector(
      '[data-target="accordion-content"]'
    );
    accordion.dataset.state = "open";
    gsap.to(content, { height: "auto", duration: 0.5 });
    gsap.to(accordion.querySelector(".icon .plus-vertical"), {
      rotate: "-90deg",
      transformOrigin: "center",
      duration: 0.5,
    });
  });
}

function ifAccordionOpenSignMinus(){
	const openAccordions = document.querySelectorAll('[data-target="accordion"][data-state="open"]');

	if ( openAccordions.length > 0 ){
		openAccordions.forEach((accordion) => {
			gsap.to(accordion.querySelector(".icon .plus-vertical"), {
				rotate: "-90deg",
				transformOrigin: "center",
				duration: 0.5,
			});
		});
	}
}

function accordion() {
  const accordions = document.querySelectorAll('[data-target="accordion"]');

  if (!accordions) return;

  ifAccordionOpenSignMinus()

  accordions.forEach((accordion) => {
    const trigger = accordion.querySelector(
      '[data-target="accordion-trigger"]',
      accordion
    );
    const content = accordion.querySelector(
      '[data-target="accordion-content"]',
      accordion
    );

    trigger.addEventListener("click", (event) => {
      const { state } = accordion.dataset;

      closeAllAccordions(accordions, event.currentTarget.parentNode);

      if (state === "closed") {
        accordion.dataset.state = "open";
        gsap.to(content, { height: "auto", duration: 0.5 });
        gsap.to(accordion.querySelector(".icon .plus-vertical"), {
          rotate: "-90deg",
          transformOrigin: "center",
          duration: 0.5,
        });
      } else {
        accordion.dataset.state = "closed";
        gsap.to(content, { height: 0, duration: 0.5 });
        gsap.to(accordion.querySelector(".icon .plus-vertical"), {
          rotate: "0deg",
          transformOrigin: "center",
          duration: 0.5,
        });
      }
    });
  });
  
  
}

(function ( $ ) {
  "use strict";
  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    //console.log("ajax complete");
    accordion();
    openAllAccordions();
    magnificPopupInline();
  });
}(jQuery))

export default accordion;
